import { Context } from "@nuxt/types";

import { UserRole } from "~/enums";

/**
 * Keep the old /submissions list ("poor old design") away from client users --
 * card 20260822-1721-submissions-page. It stays reachable for admins/experts
 * (they use the primary-nav "Case Submissions" screen), and clients still open
 * an individual case at /submissions/:id from the dashboard, so this only
 * bounces the *bare* list route and only for clients. Registered as a global
 * middleware after "auth" in nuxt.config so $auth.user is populated.
 */
export default function hideOldSubmissions({ app, route, redirect }: Context) {
  const user = app.$auth && app.$auth.user;
  if (!user || (user as any).user_role !== UserRole.Client) return;

  if (/^\/submissions\/?$/.test(route.path)) {
    redirect("/");
  }
}
